var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95275 10C6.71041 8.90906 8.90906 6.71042 10 3.95275C11.0909 6.71042 13.2896 8.90906 16.0472 10C13.2896 11.0909 11.0909 13.2896 10 16.0473C8.90906 13.2896 6.71041 11.0909 3.95275 10Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13C16.3333 14.8409 14.8409 16.3333 13 16.3333C14.8409 16.3333 16.3333 17.8257 16.3333 19.6667C16.3333 17.8257 17.8257 16.3333 19.6667 16.3333C17.8257 16.3333 16.3333 14.8409 16.3333 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 0C3.33333 1.84095 1.84095 3.33333 0 3.33333C1.84095 3.33333 3.33333 4.82572 3.33333 6.66667C3.33333 4.82572 4.82572 3.33333 6.66667 3.33333C4.82572 3.33333 3.33333 1.84095 3.33333 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.03c731bb858aaefeed4ed76f07027eb6.svg";
export { ForwardRef as ReactComponent };